// CCS-431: keeps the Care Notes Report (filters, results, search, sort, page,
// selection) while the user visits a shift and comes back. Held in memory
// only: care notes are never written to localStorage/sessionStorage, and a
// page reload or "Clear filters" discards it. Scoped to the signed-in user so
// another user on the same browser never sees it.
let saved = null;

export const currentUserId = (storage = window.localStorage) => {
  try {
    const user = JSON.parse(storage.getItem("user"));
    return user?.id ?? user?.username ?? null;
  } catch {
    return null;
  }
};

export const loadReportState = (userId) =>
  saved && userId && saved.userId === userId ? saved.state : null;

export const saveReportState = (userId, state) => {
  saved = userId ? { userId, state } : null;
};

export const clearReportState = () => {
  saved = null;
};
